import MotionWrapper from '../../../../containers/MotionWrapper';
import Button from '../../../../components/Button';
import { useNavigate } from 'react-router-dom';
import styles from './style.module.scss';

function Approval() {
    const navigate = useNavigate();

    return (
        <MotionWrapper className={styles.wrapper}>
            <span className={styles.title}>
                Your password changed successfully
            </span>
            <p className={styles.text}>
                Use your new password to sign in.
            </p>
            <Button
                type='Primary'
                text='Sign in now'
                onClick={() => navigate('/signin')}
            />
        </MotionWrapper>
    )
};

export default Approval;
